import dataModel from '../../models/DataModel.js';
import projectsService from '../../services/projectsService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';

export default class ProjectReportCollection extends AOCollection {
  /**
   * @param {object} filter - has the following properties:
   *  - searchString (string)
   *  - sortField (string)
   *  - ascending (boolean)
   *  - showArchived (boolean)
   */
  constructor(perPage, filter, userId, companyId, recordDescriptor) {
    super({
      name: ReduxConstants.PROJECTS_REPORT,
      collectionType: ReduxConstants.PROJECT,
      perPage, 
      filter,
      userId,
      companyId,
      recordDescriptor,
    });
  }

  static build(perPage, filter, userId, companyId, recordDescriptor) {
    const collection = new ProjectReportCollection(perPage, filter, userId, companyId, recordDescriptor);
    const collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collection._recordState = '';
      dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType(), recordDescriptor);
    }
    else {
      collection._filter = collectionData._filter;
      collection.ids = collectionData.ids;
      collection.page = collectionData.page;
      collection.perPage = collectionData.perPage;
      collection.meta = collectionData.meta;
      collection.recordDescriptor = collectionData.recordDescriptor;
    }
    return collection;
  }

  handleOffLineFetch(options) {
    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchNext(pageOverride, options = {}) {
    let marketIds = await dataModel.usersDAO.getEditorUserMarkets(this.userId ? this.userId : dataModel.usersDAO.currentUser.id);

    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      if (pageOverride) {
        this.page = pageOverride;
      }
      this.page++;

      const { searchString, sortField, ascending, showArchived } = this._filter;
      
      let serviceCall = projectsService.searchProjectReport.bind(this, searchString, { ...this._filter }, false, sortField, ascending, null, this.page, this.perPage, this.companyId, false, showArchived, { marketIds, recordDescriptor: this.recordDescriptor });
      let newCollection = await this._fetchData(serviceCall, options, true);
      if (newCollection.offline) {
        return this.handleOffLineFetch(options);
      }
      return newCollection;
    }
  }

  async fetchCurrent(shouldPaginate = true, options = {}) {
    let marketIds = await dataModel.usersDAO.getEditorUserMarkets(this.userId ? this.userId : dataModel.usersDAO.currentUser.id);

    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      let collection = this.findCollection();

      let page = null;
      let perPage = null;
      
      // Get everything we already got
      if (shouldPaginate) {
        page = 1;
        if (collection && collection.perPage) {
          perPage = Math.max(this.perPage, collection.ids.length);
        }
      }
      
      const { searchString, sortField, ascending, showArchived } = this._filter;
      let serviceCall = projectsService.searchProjectReport.bind(this, searchString, { ...this._filter }, false, sortField, ascending, null, page, perPage, this.companyId, false, showArchived, { marketIds, recordDescriptor: this.recordDescriptor });

      let newCollection = await this._fetchData(serviceCall, options);
      if (newCollection.offline) {
        return this.handleOffLineFetch(options);
      }
      return newCollection;
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/ProjectReportCollection.js